import React from "react";
const TmsPosPrasadamScan = () => {
  return <div>Prasadam Scan</div>;
};
export default TmsPosPrasadamScan;
